var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.4264 16H22.5736C18.9431 16 16 18.9431 16 22.5736V41.4264C16 45.0569 18.9431 48 22.5736 48H41.4264C45.0569 48 48 45.0569 48 41.4264V22.5736C48 18.9431 45.0569 16 41.4264 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.3263 22H42.6998L35.3297 30.4718L44 42H37.2112L31.894 35.0082L25.8099 42H22.4344L30.3174 32.9385L22 22H28.9611L33.7674 28.3908L39.3263 22ZM38.1423 39.9692H40.0116L27.9454 23.9241H25.9395L38.1423 39.9692Z",
    fill: "#05141F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.dd0c7bbbb54fb34233ba0b8533d56934.svg";
export { ForwardRef as ReactComponent };